export const routes = [
  {
    key: "1",
    path: "./",
    pathlargo: "/bikiforge/",
    exact: true,
    text: "articles",
    icon: "unordered-list"
  },
  {
    key: "2",
    path: "./list-design-process",
    pathlargo: "/bikiforge/list-design-process",
    exact: true,
    text: "designs",
    icon: "unordered-list"
  },
  {
    key: "3",
    path: "./manufacturing-order",
    pathlargo: "/bikiforge/manufacturing-order",
    exact: true,
    text: "manufacturig_order",
    icon: "border"
  },
  {
    key: "4",
    path: "./control-process",
    pathlargo: "/bikiforge/control-process",
    exact: true,
    text: "control_process",
    icon: "control"
  }

];
